module.exports = __webpack_public_path__ + "static/media/detail44.6a43006d.svg";